<ion-card [ngClass]="{ isPopover: isPopover, 'wallet-card': true }" color="primary">
  <ion-item
    lines="none"
    [color]="isAward ? 'secondary' : isBonus ? 'tertiary' : 'primary'"
    [button]="isPopover"
    (click)="clickDetail()"
  >
    <ion-label>
      <p>
        <strong>{{ isAward ? 'Wallet premios' : isBonus ? 'Wallet bonos' : 'CMillonario wallet' }}</strong>
      </p>
      <small>{{ email }}</small>
    </ion-label>
    @if(isPopover) {
    <ion-icon slot="end" name="arrow-forward"></ion-icon>
    } @else if(isAward || isBonus) {
    <ion-icon slot="end" name="sparkles-outline"></ion-icon>
    }
  </ion-item>
  <ion-row class="card-header">
    <ion-col size="8">
      @if(!isAward && !isBonus && wallets.length) {
      <ion-accordion-group (ionChange)="sortWallets()">
        <ion-accordion value="first">
          <ion-item slot="header" color="primary" lines="none">
            <ion-label class="ion-no-margin">
              <h3 class="balance-label">Saldo disponible <span *ngIf="isAward">para retirar</span></h3>
              @if(balance < 1000000) {
              <h1 class="balance-amount">
                <ion-spinner *ngIf="isLoading" class="spinner" color="secondary" name="dots"></ion-spinner>
                <span *ngIf="!isLoading"
                  >{{ balance | currency | slice : 0 : -3 }}<small>.{{ balance | currency | slice : -2 }}</small></span
                >
              </h1>
              } @else {
              <h3 class="balance-big-amount">
                <ion-spinner *ngIf="isLoading" class="spinner" color="secondary" name="dots"></ion-spinner>
                <span *ngIf="!isLoading"
                  >{{ balance | currency | slice : 0 : -3 }}<small>.{{ balance | currency | slice : -2 }}</small></span
                >
              </h3>
              }
            </ion-label>
          </ion-item>
          <div class="ion-no-padding" slot="content">
            @for(w of wallets; track w.id;){
            <ion-item color="primary" lines="none">
              <ion-label class="ion-no-margin">
                <p>
                  <small>
                    {{ 'wallets.name.' + w.walletName | translate }}
                  </small>
                </p>
                <p>
                  <strong>
                    {{ w.balance | currency }}
                  </strong>
                </p>
              </ion-label>
            </ion-item>
            }
          </div>
        </ion-accordion>
      </ion-accordion-group>
      } @else{
      <!-- <h2 *ngIf="!isPopover" class="wallet-label">CMillonario wallet</h2>
        <p *ngIf="!isPopover" class="ion-no-margin"><small>{{email}}</small></p> -->
      <h3 class="ion-padding-start balance-label">Saldo disponible <span *ngIf="isAward">para retirar</span></h3>
      <h1 class="ion-padding-start balance-amount">
        <ion-spinner *ngIf="isLoading" class="spinner" color="secondary" name="dots"></ion-spinner>
        <span *ngIf="!isLoading"
          >{{ balance | currency | slice : 0 : -3 }}<small>.{{ balance | currency | slice : -2 }}</small></span
        >
      </h1>
      }
      <ion-button
        fill="outline"
        shape="round"
        color="secondary"
        size="small"
        class="balance-add"
        (click)="openAddFundsOrTransferModal()"
        [disabled]="isAward && balance < 100"
      >
        <ion-label> {{ isAward ? 'Transferir' : 'Agregar Saldo' }} </ion-label>
        <ion-icon slot="end" [name]="isAward ? 'send-outline' : 'add'"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col size="4" class="card-icon ion-no-padding">
      <ion-img src="./assets/logos/cmillonario-icon-lightbg.svg"></ion-img>
      <!-- <p class="wallet-id">
        <small>Wallet id</small>
        <br />
        <span>{{ walletId | slice : 13 }}</span>
      </p> -->
    </ion-col>
  </ion-row>
</ion-card>
